import { styled, Theme } from '@mui/material/styles';
import { SxProps } from '@mui/system';
import { FC, ReactNode } from 'react';
import { useTheme } from '@mui/material';
import { TCustomTheme } from '@mgm/common/theme';
import { useCustomTheme } from '@mgm/common/hooks/useCustomTheme';

const StyledIcon = styled('div')(({ theme, sx, isMobile }: {
  theme?: Theme
  sx: SxProps<Theme> & { backgroundImage: string; iconColor?: string }
  isMobile: boolean
}) => ({
  margin: isMobile ? 0 : 'auto',
  display: 'flex',
  borderRadius: '50%',
  alignItems: 'center',
  width: theme?.spacing(8),
  height: theme?.spacing(8),
  justifyContent: 'center',
  marginBottom: theme?.spacing(isMobile ? 0 : 3),
  color: sx.iconColor,
  backgroundImage: sx.backgroundImage,
}));

type TTotalIconWrapper = {
  children: ReactNode,
  sx: SxProps<Theme> & { backgroundImage: string; iconColor?: string }
};

const TotalIconWrapper: FC<TTotalIconWrapper> = ({ children, sx }) => {
  const theme = useTheme() as TCustomTheme;
  const { isMobile } = useCustomTheme(theme);

  return (
    <StyledIcon sx={sx} isMobile={isMobile}>
      {children}
    </StyledIcon>
  );
};

export {
  TotalIconWrapper,
};
